import React from 'react';
import validator from 'validator';
import CompanyForm from '../company/CompanyForm';
import GreenLeafApi from '../utils/GreenLeafApi';
import EditPage from '../EditPage';

class EditCompanyPage extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      isCreating: !props.match.params.id,
      errors: {},
      error: [],
      company: {
        name: '',
        primary_aim_id: null
      }
    };

    this.saveCompany = this.saveCompany.bind(this);
    this.updatePrimaryAim = this.updatePrimaryAim.bind(this);
    this.updateCompanyState = this.updateCompanyState.bind(this);
    this.cancel = this.cancel.bind(this);
  }

  async componentDidMount() {
    if (!this.state.isCreating) {

      try {
        const companies = await GreenLeafApi.Company.get({id: this.props.match.params.id});
        if (companies.isOkay) {
          this.setState({company: companies.data[0]});
        } else {
          this.setState({ error: companies.errors });
        }
      } catch (e) {
        this.setState({error: e.errors});
      }

    }
  }

  async saveCompany(event) {
    event.preventDefault();
    if(this.validate(this.state)) {
      let company = this.state.company;
      if(!company.primary_aim_id) {
        delete company.primary_aim_id;
      }
      try {
        await (this.state.isCreating ? GreenLeafApi.Company.create(company)
          : GreenLeafApi.Company.update(company));
        this.props.history.goBack();
      } catch (e) {
        this.setState({error: e.errors});
      }
    }
  }

  updateCompanyState(event) {
    let errors = this.state.errors;
    const field = event.target.name;
    errors[field] = null;
    let state = { errors, company: this.state.company };
    state.company[field] = event.target.value;
    return this.setState(state);
  }

  updatePrimaryAim(id) {
    let state = this.state;
    state.company.primary_aim_id = id;

    return this.setState(state);
  }

  cancel() {
    this.props.history.goBack();
  }

  validate() {
    const requiredFields = ['name'];
    let errors = {};

    requiredFields.forEach(f => {
      if (validator.isEmpty(this.state.company[f])) {
        errors[f] = 'This is a required field.';
      }
    });

    this.setState({errors: errors});
    return Object.keys(errors).length === 0;
  }

  render() {
    return (
      <EditPage
        editType={'Company'}
        isCreating={!this.props.match.params.id}
        error={this.state.error}>
        <CompanyForm
          preset={this.state.company}
          errors={this.state.errors}
          onSave={this.saveCompany}
          onChange={this.updateCompanyState}
          onChangeAim={this.updatePrimaryAim}/>
      </EditPage>
    );
  }
}

export default EditCompanyPage;


// WEBPACK FOOTER //
// ./src/components/company/EditCompanyPage.js